













































































import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';

import axios from 'axios';
import ProjectService from '@/entities/project/project.service';
import { Permission } from '@/shared/model/permission.model';
import UserPrivilegeService from '@/entities/user-privilege/user-privilege.service';
import { UserPrivilege } from '@/shared/model/user-privilege.model';
import UserManagementService from '@/admin/user-management/user-management.service';

@Component
export default class PermissionConfigPage extends Vue {
  selectedProjects = [];
  selectedUsers = [];
  selectedPermissions = [];
  projects = [];
  users = [];
  permissions = [
    // { id: "CREATE", name: "Quyền tạo" },
    { id: 'READ', name: 'Quyền xem' },
    { id: 'UPDATE', name: 'Quyền sửa' },
    { id: 'DELETE', name: 'Quyền xóa' },
  ];
  private userPrivileges: UserPrivilege[] = [];
  private userToUserPrivilege: Map<number, UserPrivilege> = new Map();

  async mounted() {
    await this.fetchProjects();
    await this.fetchUsers();
    await this.fetchUserPrivileges();
  }

  async fetchProjects() {
    try {
      const response = await new ProjectService().retrieve({ page: 0, size: 10000 });
      this.projects = response.data;
      this.projects = this.projects.sort((a, b) => a.name.localeCompare(b.name)); // sort by name
    } catch (error) {
      console.error(error);
    }
  }

  async fetchUsers() {
    try {
      const response = await new UserManagementService().retrieve({ page: 0, size: 10000 });
      this.users = response.data;
      this.users = this.users.sort((a, b) => a.login.localeCompare(b.login)); // sort by login
    } catch (error) {
      console.error(error);
    }
  }

  async fetchUserPrivileges() {
    try {
      const response = await new UserPrivilegeService().retrieve({ page: 0, size: 10000 });
      this.userPrivileges = response.data;
      this.userPrivileges.forEach(userPrivilege => {
        this.userToUserPrivilege.set(userPrivilege.user.id, userPrivilege);
      });
    } catch (error) {
      console.error(error);
    }
  }

  async grantPermission() {
    if (this.selectedProjects.length === 0) {
      if (this.selectedUsers.length !== 0 || this.selectedPermissions.length === 1) {
        if (this.selectedPermissions[0].id === 'CREATE') {
        } else {
          const successMessage = 'Bạn phải chọn ít nhất một dự án và user để cấp quyền';
          (this.$root as any).$bvToast.toast(successMessage, {
            toaster: 'b-toaster-top-center',
            title: 'Thông báo',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
          return;
        }
      }
      const successMessage = 'Bạn phải chọn ít nhất một dự án để cấp quyền';
      (this.$root as any).$bvToast.toast(successMessage, {
        toaster: 'b-toaster-top-center',
        title: 'Thông báo',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
      return;
    }
    let permissions = [];
    let selectedPermissionIds = new Set();
    this.selectedPermissions.forEach(permission => {
      selectedPermissionIds.add(permission.id);
    });
    this.selectedUsers.forEach(user => {
      this.selectedProjects.forEach(project => {
        if (selectedPermissionIds.has('CREATE')) {
          permissions.push({
            project: null,
            userPrivilege: { id: this.userToUserPrivilege.get(user.id).id },
            createPermission: true,
            readPermission: false,
            updatePermission: false,
            deletePermission: false,
          });
        }
        let permission = new Permission();
        permission.project = { id: project.id };
        permission.userPrivilege = { id: this.userToUserPrivilege.get(user.id).id };
        permission.createPermission = false;
        permission.readPermission = selectedPermissionIds.has('READ');
        permission.updatePermission = selectedPermissionIds.has('UPDATE');
        permission.deletePermission = selectedPermissionIds.has('DELETE');
        permissions.push(permission);
      });
    });

    try {
      const response = await axios.post('api/permissions-merge', permissions);
      console.log(response);
      const successMessage = 'Cấp quyền thành công';
      (this.$root as any).$bvToast.toast(successMessage, {
        toaster: 'b-toaster-top-center',
        title: 'Info',
        variant: 'info',
        solid: true,
        autoHideDelay: 5000,
      });
    } catch (error) {
      console.error(error);
      const errorMessage = 'Cấp quyền thất bại';
      (this.$root as any).$bvToast.toast(errorMessage, {
        toaster: 'b-toaster-top-center',
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    }
  }
}
